<template>
  <div class="spinner-loader">
    <div class="spinner-loader__inner">
      <div
        v-for="(_item, idx) in items"
        :key="idx"
        class="spinner-loader__item"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const items = Array.from({ length: 8 });
</script>

<style lang="scss" scoped>
@import './SpinnerLoader';
</style>
